<!-- <div class="container-fluid pt-2">
  <ul class="custom-tabset">
    <li *ngFor="let step of steps;let index=index">
      <div class="step-title" *ngIf="step.status != 4" (click)="setActiveStepper(index, step.type, step)"
        [ngClass]="{'active':index == current_step.index}">
        <img class="step-title-icon mr-1" [src]="step.icon" alt="">
        {{step.title | translate}}
      </div>
    </li>
  </ul>

  <div *ngIf="refresh_flag" class="h-100 oveflow-auto">
    <app-pre-offer [first_login_details]="first_login_details" [disable_action]="steps[current_step.index].status != 1"
      (formSaved)="updateJourenyDetails($event)"
      *ngIf="current_step['type'] == 1  && [1,2].indexOf(steps[current_step.index].status) > -1">
    </app-pre-offer>

    <app-offer-details [first_login_details]="first_login_details"
      [disable_action]="steps[current_step.index].status != 1" (formSaved)="updateJourenyDetails($event)"
      *ngIf="current_step['type'] == 2 && [1,2].indexOf(steps[current_step.index].status) > -1">
    </app-offer-details>

    <app-onboarding-details [first_login_details]="first_login_details"
      [disable_action]="steps[current_step.index].status != 1" (formSaved)="updateJourenyDetails($event)"
      *ngIf="current_step['type'] == 3 && [1,2].indexOf(steps[current_step.index].status) > -1">
    </app-onboarding-details>

    <app-appointment-details [first_login_details]="first_login_details"
      [disable_action]="steps[current_step.index].status != 1" (formSaved)="updateJourenyDetails($event)"
      *ngIf="current_step['type'] == 4 && [1,2].indexOf(steps[current_step.index].status) > -1">
    </app-appointment-details>

    <app-applicant-feedback [disable_action]="steps[current_step.index].status != 1"
      *ngIf="current_step['type'] == 5 && [1,2].indexOf(steps[current_step.index].status) > -1">
    </app-applicant-feedback>


    <div *ngIf="!current_step.type ||  [1,2].indexOf(steps[current_step.index].status) == -1"
      class="text-center pt-4 pb-4" style="margin: 50px 0 !important;">
      <span *ngIf="steps && steps[current_step.index] && steps[current_step.index].status == 3">
        {{'MY_JOYRNEY.disabled' | translate}}
      </span>
      {{'MY_JOYRNEY.message' | translate}}
    </div>
  </div>
</div> -->

<div class="container-fluid">
  <div class="col-md-12 padding-sm-0">
    <div class="tab-container">
      <!-- <ul class="nav nav-tabs">
        <ng-container *ngFor="let step of steps;let index=index">
          <li *ngIf="step.status != 4" [ngClass]="{'active':index == current_step.index}"
            (click)="setActiveStepper(index, step.type, step)">
            <a>
              {{step.title | translate}}
            </a>
          </li>
        </ng-container>
      </ul> -->

      <div class="wrapper my-4">
        <nav class="tabs">
          <div class="selector"></div>
          <ng-container *ngFor="let step of steps;let index=index">
            <!-- <span [id]="'class'+index"></span> -->
            <a *ngIf="step.status != 4" [ngClass]="{'active':index == current_step.index}"
              (click)="setActiveStepper(index, step.type, step)">
              {{step.title | translate}}
            </a>
          </ng-container>
        </nav>
      </div>

      <div *ngIf="refresh_flag" class="h-100 oveflow-auto tab-content">
        <app-pre-offer [first_login_details]="first_login_details"
          [disable_action]="steps[current_step.index].status != 1" (formSaved)="updateJourenyDetails($event)"
          *ngIf="current_step['type'] == 1  && [1,2].indexOf(steps[current_step.index].status) > -1">
        </app-pre-offer>

        <app-offer-details [first_login_details]="first_login_details"
          [disable_action]="steps[current_step.index].status != 1" (formSaved)="updateJourenyDetails($event)"
          *ngIf="current_step['type'] == 2 && [1,2].indexOf(steps[current_step.index].status) > -1">
        </app-offer-details>

        <app-onboarding-details [first_login_details]="first_login_details"
          [disable_action]="steps[current_step.index].status != 1" (formSaved)="updateJourenyDetails($event)"
          *ngIf="current_step['type'] == 3 && [1,2].indexOf(steps[current_step.index].status) > -1">
        </app-onboarding-details>

        <app-appointment-details [first_login_details]="first_login_details"
          [disable_action]="steps[current_step.index].status != 1" (formSaved)="updateJourenyDetails($event)"
          *ngIf="current_step['type'] == 4 && [1,2].indexOf(steps[current_step.index].status) > -1">
        </app-appointment-details>

        <app-applicant-feedback [disable_action]="steps[current_step.index].status != 1"
          *ngIf="current_step['type'] == 5 && [1,2].indexOf(steps[current_step.index].status) > -1">
        </app-applicant-feedback>

        <app-offer-details [first_login_details]="first_login_details" [type]="6"
          [disable_action]="steps[current_step.index].status != 1" (formSaved)="updateJourenyDetails($event)"
          *ngIf="current_step['type'] == 6 && [1,2].indexOf(steps[current_step.index].status) > -1">
        </app-offer-details>


        <div *ngIf="!current_step.type ||  [1,2].indexOf(steps[current_step.index].status) == -1"
          class="text-center pt-4 pb-4" style="margin: 50px 0 !important;">
          <span *ngIf="steps && steps[current_step.index] && steps[current_step.index].status == 3">
            {{'MY_JOYRNEY.disabled' | translate}}
          </span>
          {{'MY_JOYRNEY.message' | translate}}
        </div>
      </div>
    </div>
  </div>
</div>
